import { render, staticRenderFns } from "./fieldDecimal.vue?vue&type=template&id=d3863ce4&"
import script from "./fieldDecimal.vue?vue&type=script&lang=js&"
export * from "./fieldDecimal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports